import {LitElement} from 'lit';
import {html} from 'lit/html.js';

import css from './tt-gamelist.pcss';

import '@polymer/paper-card'

import '../dttb-heading'
import './../tt-game-row/tt-game-row'

export default class TTGamelist extends LitElement {
    static get properties() {
        return {
            games: {
                type: Array
            }
        };
    }

    constructor() {
        super();
        this.games = [];
    }

    static get styles() {
        return [css];
    }

    render() {
        return html`
            ${this.games.map(d => this.renderDay(d))}
        `
    }

    renderDay(day) {
        return html`
            <dttb-heading date="${day.date}"></dttb-heading>
            ${day.entries.map(l => this.renderLeague(l))}
        `
    }

    renderLeague(league) {
        return html`
        <h4>${league.league}</h4>
        <paper-card style="width: 100%">
            ${league.games.map(g => this.renderGame(g))}
        </paper-card>
        `
    }

    renderGame(game) {
        return html`<tt-game-row .game=${game} displayTime=true></tt-game-row>`
    }

}

window.customElements.define('tt-gamelist', TTGamelist);
